webpackJsonp([27],{

/***/ "UuJc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  query DeputatiQuery($lang: String!, $domes_partija: [String], $domes_piederiba: [String], $perpage: Int, $page: Int, $orderby: [String], $order: [String]) {\n      dome(lang: $lang, domes_partija: $domes_partija, domes_piederiba: $domes_piederiba, perpage: $perpage, page: $page, orderby: $orderby, order: $order) {\n        posts {\n          _id\n          path\n          title\n          path\n          content\n          acf\n          images {\n            thumb(size: ["card-default"]) {\n              url\n              retina\n              width\n              height\n            }\n          }\n          terms {\n            domes_partija {\n              name\n            }\n            domes_piederiba {\n              name\n            }\n          }\n        }\n      }\n      teksti(lang: $lang, _id:["partija"]) {\n          _id\n          text\n      }\n  }\n'], ['\n  query DeputatiQuery($lang: String!, $domes_partija: [String], $domes_piederiba: [String], $perpage: Int, $page: Int, $orderby: [String], $order: [String]) {\n      dome(lang: $lang, domes_partija: $domes_partija, domes_piederiba: $domes_piederiba, perpage: $perpage, page: $page, orderby: $orderby, order: $order) {\n        posts {\n          _id\n          path\n          title\n          path\n          content\n          acf\n          images {\n            thumb(size: ["card-default"]) {\n              url\n              retina\n              width\n              height\n            }\n          }\n          terms {\n            domes_partija {\n              name\n            }\n            domes_piederiba {\n              name\n            }\n          }\n        }\n      }\n      teksti(lang: $lang, _id:["partija"]) {\n          _id\n          text\n      }\n  }\n']);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactApollo = __webpack_require__("3zLD");

var _graphqlTag = __webpack_require__("tlQw");

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _pages = __webpack_require__("04qB");

var _reactRedux = __webpack_require__("RH2O");

var _LoadingActions = __webpack_require__("tuf/");

var _LoadingActions2 = _interopRequireDefault(_LoadingActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var QUERY = (0, _graphqlTag2.default)(_templateObject);
var ITEMS_PER_PAGE = 999;
var queryOptions = {
  options: function options(props) {
    var lang = props.lang;

    return {
      fetchPolicy: 'cache-first',
      variables: {
        lang: lang || 'lv',
        domes_partija: null,
        domes_piederiba: 'domes-deputati',
        perpage: ITEMS_PER_PAGE,
        // page: $page,
        orderby: 'menu_order',
        order: 'asc'
      }
    };
  },
  props: function props(_props) {
    var data = _props.data,
        lang = _props.lang;

    var _props$data = _props.data,
        loading = _props$data.loading,
        dome = _props$data.dome,
        teksti = _props$data.teksti,
        rest = _objectWithoutProperties(_props$data, ['loading', 'dome', 'teksti']);

    return {
      lang: _props.ownProps.lang,
      loading: loading,
      data: {
        dome: dome,
        teksti: teksti,
        type: 'domes-deputati',
        page: _props.ownProps.init_page
      }
    };
  }
};

var PageDomesDeputati = function (_React$PureComponent) {
  _inherits(PageDomesDeputati, _React$PureComponent);

  function PageDomesDeputati(props) {
    _classCallCheck(this, PageDomesDeputati);

    var _this = _possibleConstructorReturn(this, (PageDomesDeputati.__proto__ || Object.getPrototypeOf(PageDomesDeputati)).call(this, props));

    _this.state = {
      page: 0,
      total: 0
    };
    return _this;
  }

  _createClass(PageDomesDeputati, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.loading) {
        this.props.loadingStatuss({ _id: this.props.path + '__', loading: true });
      } else if (!this.props.loading && this.props.global_loading && this.props.global_loading[this.props.path + '__'] === true) {
        this.props.loadingStatuss({ _id: this.props.path + '__', loading: false });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.loading && nextProps.global_loading[nextProps.path + '__'] === false) {
        nextProps.loadingStatuss({ _id: nextProps.path + '__', loading: true });
      } else if (!nextProps.loading && nextProps.global_loading[nextProps.path + '__'] === true) {
        nextProps.loadingStatuss({ _id: nextProps.path + '__', loading: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      if (props.loading) {
        return null;
      }
      return _react2.default.createElement(_pages.Deputati, { data: props.data, lang: props.lang, path: props.history.location.pathname });
    }
  }]);

  return PageDomesDeputati;
}(_react2.default.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  // console.log(state)
  return {
    global_loading: state.global_loading
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    loadingStatuss: function loadingStatuss(LOADING) {
      dispatch((0, _LoadingActions2.default)(LOADING));
    }
  };
};

exports.default = (0, _reactApollo.compose)((0, _reactApollo.graphql)(QUERY, queryOptions), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(PageDomesDeputati);

/***/ })

});


// WEBPACK FOOTER //
// PageDomesDeputati.c557a7058032236ec3e8.js